import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "tcng_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const adminApi = () =>
  axios.create({
    baseURL: API,
    headers: { Authorization: `Bearer ${getToken()}` },
  });

export const publicApi = axios.create({ baseURL: API });
